module.exports = new __parcel__URL__("figurative.e483ba6a.png").toString();